module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/railSprite2.730f114c.png";